<template>
  <div>
    <div class="white-container duration-edit">
      <el-row :gutter="20">
        <el-col :span="3">
          <div class="duration-label">教练头像</div>
        </el-col>
        <el-col :span="19"><img :src="coachItem.avatar" alt="" class="user-logo"></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="3">
          <div class="duration-label">教练姓名</div>
        </el-col>
        <el-col :span="19">{{ coachItem.name || "-" }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="3">
          <div class="duration-label">教练级别</div>
        </el-col>
        <el-col :span="19">{{ handleFixLevel(coachItem.level) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="3">
          <div class="duration-label">手机号</div>
        </el-col>
        <el-col :span="19">{{ coachItem.phone || "-" }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="3">
          <div class="duration-label">城市</div>
        </el-col>
        <el-col :span="19">{{ coachItem.city || "-" }}</el-col>
      </el-row>
    </div>
    <!--任务明细-->
    <div class="white-container task-detail">
      <div>任务明细</div>
      <div class="task-detail-info flex">
        <div class="flex-item">
          <span style="margin-right: 10px">统计周期</span>
          <el-date-picker v-model="dateMonth" value-format="yyyy-MM" :picker-options="pickerMonthOptions" type="month" placeholder="选择月" style="width: 180px" @change="dateMonthChange" />
        </div>
        <div class="time text-right">总次数：{{ coachItem.totalNumberOfTasks }}</div>
        <div class="duration">总时长：{{ coachItem.totalTaskDuration }}</div>
      </div>
      <div v-if="coachItem.coachTaskType.some(item => item.type === 1)" class="detail-table">
        <div class="detail-table_head flex">
          <div class="flex-item">活动</div>
          <div class="time text-right">次数：{{ coachItem.coachTaskType[coachTaskTypeIndex(1)].totalNumberOfTasks }}</div>
          <div class="duration">时长：{{ coachItem.coachTaskType[coachTaskTypeIndex(1)].totalTaskDuration }}
          </div>
        </div>
        <div class="detail-table_body">
          <div
            v-for="item in coachItem.coachTaskType[coachTaskTypeIndex(1)].coachTaskDetails"
            :key="item.id"
            class="flex row"
          >
            <div class="flex-item name">
              <div class="label">任务</div>
              <div class="content">{{ item.name }}</div>
            </div>
            <div class="flex-item time-cont">
              <div class="label">时间</div>
              <div class="content">
                {{ `${item.beginTime}` | dateFormat }} -
                {{ `${item.endTime}` | dateFormat }}
              </div>
            </div>
            <div class="duration-time">
              <div class="label w56">任务时长</div>
              <div class="content">{{ item.duration }}</div>
            </div>
            <div class="operation" />
          </div>
        </div>
      </div>

      <!--训练营-->
      <div v-if="coachItem.coachTaskType.some(item => item.type === 2)" class="detail-table">
        <div class="detail-table_head flex">
          <div class="flex-item">训练营Camp</div>
          <div class="time text-right">次数：{{ coachItem.coachTaskType[coachTaskTypeIndex(2)].totalNumberOfTasks }}
          </div>
          <div class="duration">时长：{{ coachItem.coachTaskType[coachTaskTypeIndex(2)].totalTaskDuration }}
          </div>
        </div>
        <div class="detail-table_body">
          <div
            v-for="(item, index) in coachItem.coachTaskType[coachTaskTypeIndex(2)].coachTaskDetails"
            :key="item.id"
            class="flex row"
          >
            <div class="flex-item name">
              <div class="label">任务</div>
              <div class="content">{{ item.name }}</div>
            </div>
            <div class="flex-item time-cont">
              <div class="label">时间</div>
              <div class="content">
                {{ `${item.beginTime}` | dateFormat }} -
                {{ `${item.endTime}` | dateFormat }}
              </div>
            </div>
            <div class="duration-time">
              <div class="label w56">任务时长</div>
              <div v-if="!item.edit" class="content">{{ Number(item.duration) + Number(item.revised) }}</div>
              <template v-else>
                <div class="edit-duration">
                  <span>{{ item.duration }}</span>
                  <span>+</span>
                  <el-input v-model="item.revised" autocomplete="off" style="width: 60px; text-align: center" @change="item.revised = validateRevised(item.duration,item.revised)" />
                </div>
              </template>
            </div>
            <div class="operation">
              <el-button v-if="item.edit" type="text" class="link-color" @click="commit(item, index, 2)">确认</el-button>
              <el-button v-if="item.edit" type="text" class="link-color" @click="cancel(item)">取消</el-button>
              <el-button v-else type="text" class="link-color" @click="item.edit = true">编辑</el-button>
            </div>
          </div>
        </div>
      </div>

      <!--其他-->
      <div v-if="coachItem.coachTaskType.some(item => item.type === 3)" class="detail-table">
        <div class="detail-table_head flex">
          <div class="flex-item">其他</div>
          <div class="time text-right">次数：{{ coachItem.coachTaskType[coachTaskTypeIndex(3)].totalNumberOfTasks }}
          </div>
          <div class="duration">时长：{{ coachItem.coachTaskType[coachTaskTypeIndex(3)].totalTaskDuration }}
          </div>
        </div>
        <div class="detail-table_body">
          <div
            v-for="(item, index) in coachItem.coachTaskType[coachTaskTypeIndex(3)].coachTaskDetails"
            :key="item.orderIndex"
            class="flex row"
          >
            <div class="flex-item name">
              <div class="label">任务</div>
              <div v-if="!item.edit" class="content">{{ item.name }}</div>
              <el-input v-else v-model.number="item.name" type="text" autocomplete="off" style="width: 126px; text-align: center" />
            </div>
            <div class="flex-item time-cont">
              <div class="label">时间</div>
              <div v-if="!item.edit" class="content">
                {{ `${item.beginTime}` | dateFormat }} -
                {{ `${item.endTime}` | dateFormat }}
              </div>
              <el-date-picker
                v-else
                :key="`date-${index}`"
                v-model="item.time"
                :picker-options="pickerOptions"
                type="datetimerange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 310px; text-align: center"
                @change="itemChange(item)"
              />
            </div>
            <div class="duration-time">
              <div class="label">时长</div>
              <div v-if="!item.edit" class="content">{{ item.duration }}</div>
              <el-input v-else v-model.number="item.duration" type="number" autocomplete="off" style="width: 60px; text-align: center" @keyup.native="item.duration = validateInput(item.duration)" />
            </div>
            <div class="operation">
              <el-button v-if="item.edit" type="text" class="link-color" @click="commit(item, index, 3)">确认</el-button>
              <el-button v-if="item.edit" type="text" class="link-color" @click="cancel(item)">取消</el-button>
              <el-button v-if="!item.edit" type="text" class="link-color" @click="item.edit = true">编辑</el-button>
              <el-button v-if="!item.edit" type="text" class="link-color" @click="onBeforeRemove(coachItem.coachTaskType[coachTaskTypeIndex(3)].coachTaskDetails,index)">删除</el-button>
            </div>
          </div>
          <div class="add-new-task">
            <div class="add-button" @click="add(coachItem.coachTaskType[coachTaskTypeIndex(3)].coachTaskDetails)">
              <i class="el-icon-plus" />添加新任务
            </div>
          </div>
        </div>
      </div>

      <!--UARA-->
      <div v-if="coachItem.coachTaskType.some(item => item.type === 4)" class="detail-table">
        <div class="detail-table_head flex">
          <div class="flex-item">UARA</div>
          <div class="time text-right">次数：{{ coachItem.coachTaskType[coachTaskTypeIndex(4)].totalNumberOfTasks }}</div>
          <div class="duration">时长：{{ coachItem.coachTaskType[coachTaskTypeIndex(4)].totalTaskDuration }}
          </div>
        </div>
        <div class="detail-table_body">
          <div
            v-for="item in coachItem.coachTaskType[coachTaskTypeIndex(4)].coachTaskDetails"
            :key="item.id"
            class="flex row"
          >
            <div class="flex-item name">
              <div class="label">任务</div>
              <div class="content">{{ item.name }}</div>
            </div>
            <div class="flex-item time-cont">
              <div class="label">时间</div>
              <div class="content">
                {{ `${item.beginTime}` | dateFormat }} -
                {{ `${item.endTime}` | dateFormat }}
              </div>
            </div>
            <div class="duration-time">
              <div class="label w56">任务时长</div>
              <div class="content">{{ item.duration }}</div>
            </div>
            <div class="operation" />
          </div>
        </div>
      </div>
      <el-empty v-if="!coachItem.coachTaskType.length" :image-size="200" />
      <div v-if="coachItem.coachTaskType.length" class="flex btns">
        <el-button type="info" @click="cancelBtn">取消</el-button>
        <el-button type="primary" @click="commitBtn">保存</el-button>
      </div>
    </div>
    <Dialog v-if="dialogShow" v-model="dialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import moment from "moment";
import Dialog from '@/components/Dialog';
export default {
  components: { Dialog },
  filters: {
    dateFormat: value => {
      return value ? moment(value).format("yyyy-MM-DD HH:mmA") : "";
    },
  },
  data() {
    return {
      dialogShow: false,
      information: {},
      dialogData: {},
      coachid: "",
      dateMonth: moment().format("YYYY-MM"),
      coachItem: {
        id: "",
        avatar: "",
        name: "",
        level: "",
        phone: "",
        city: "",
        totalNumberOfTasks: "",
        totalTaskDuration: "",
        coachTaskType: [],
      },
      pickerOptions: {
        disabledDate: time => {
          const now = moment(time).format("YYYY-MM-DD");
          const start = moment(new Date()).format("YYYY-MM-DD");
          return now > start;
          // return moment(params).format("YYYY-MM") !== this.dateMonth
        },
      },
      pickerMonthOptions: {
        disabledDate: value => {
          return moment(value).isAfter(new Date());
        },
      },
    };
  },
  mounted() {
    const query = this.$route.query;
    this.coachid = query.id;
    this.getTaskDetails();
  },
  methods: {
    handleFixLevel(str) {
      if (!str) return '--';
      const arr = this.$store.state.activity.coachLevels.filter(item => item.id === str);
      if (arr && arr.length) {
        return arr[0].level || '--';
      }
      return '--';
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'delete') {
        if (this.dialogData.array && this.dialogData.index) {
          this.remove(this.dialogData.array, this.dialogData.index);
        }
      }
    },
    coachTaskTypeIndex(type) {
      return (
        this.coachItem.coachTaskType.findIndex(item => item.type === type) || 0
      );
    },
    // 校验训练营时长只能为整数
    validateRevised(duration, revised) {
      let value = revised.replace(/[^\-\d]/g, ""); // 只能输入-和数字

      value = value.replace(/\-{2,}/g, "-"); // -只能保留一个

      value = value.replace(/(\d)\-/g, "$1"); // 数字后面不能接-，不能出现类似-11-2,12-，11-23

      value = value.replace(/(-)0+/g, "$1"); // 不能出现-0,-001,-0001类似

      if (value === '') {
        return 0;
      }
      const res = Number(duration) + parseInt(value);
      if (res < 0) {
        this.$message.error('任务时长不能修正为负数');
        return 0;
      }
      return parseInt(value);
    },
    // 限制只能输入数字或小数点
    validateInput(value) {
      return value ? Number(parseFloat(value).toFixed(1)) : "";
    },
    dateMonthChange() {
      this.getTaskDetails();
    },
    getTaskDetails() {
      const params = {
        coachId: this.coachid,
        dateMonth: this.dateMonth,
      };
      this.$Api.coach.getTaskDetails(params).then(res => {
        if (!res) return;
        if (res.coachTaskType.some(item => item.type === 2)) {
          const index = res.coachTaskType.findIndex(item => item.type === 2);
          res.coachTaskType[index].coachTaskDetails = res.coachTaskType[
            index
          ].coachTaskDetails.map(item => {
            item.edit = false;
            item.oldItem = JSON.stringify(item);
            return item;
          });
        }
        if (res.coachTaskType.some(item => item.type === 3)) {
          const index = res.coachTaskType.findIndex(item => item.type === 3);
          res.coachTaskType[index].coachTaskDetails = res.coachTaskType[
            index
          ].coachTaskDetails.map(item => {
            item.orderIndex = item.id;
            item.time = [item.beginTime, item.endTime];
            item.edit = false;
            item.oldItem = JSON.stringify(item);
            return item;
          });
        }
        this.coachItem = Object.assign(this.coachItem, res);
      });
    },

    commit(item, index, type) {
      if (item.duration <= 0) {
        this.$message.error("任务时长不能少于等于0");
        return false;
      }
      if (!item.name || !item.beginTime || !item.endTime || !item.duration) {
        this.$message.error("请输入完整信息");
        return false;
      }
      // item.oldItem = JSON.stringify(item)
      const copyObj = JSON.parse(JSON.stringify(this.coachItem));
      copyObj.coachTaskType[this.coachTaskTypeIndex(type)].totalNumberOfTasks =
        this.coachItem.coachTaskType[
          this.coachTaskTypeIndex(type)
        ].coachTaskDetails.length;
      const details =
        this.coachItem.coachTaskType[this.coachTaskTypeIndex(type)]
          .coachTaskDetails;
      let total = 0;
      if (Array.isArray(details) && details.length) {
        if (type === 2) {
          details.forEach(data => {
            total = total + Number(data.duration) + Number(data.revised);
          });
        } else {
          details.forEach(data => {
            total += Number(data.duration);
          });
        }
      }
      total = total.toString();
      if (total.indexOf(".") !== -1) {
        total = Number(total.substring(0, total.indexOf(".") + 2));
      }
      copyObj.coachTaskType[this.coachTaskTypeIndex(type)].totalTaskDuration = total;
      if (
        copyObj.coachTaskType[this.coachTaskTypeIndex(type)].coachTaskDetails[index]
      ) {
        copyObj.coachTaskType[this.coachTaskTypeIndex(type)].coachTaskDetails[
          index
        ].edit = false;
        copyObj.coachTaskType[this.coachTaskTypeIndex(type)].coachTaskDetails[
          index
        ].oldItem = JSON.stringify(item);
      }
      this.coachItem = Object.assign(this.coachItem, copyObj);
    },
    cancel(item) {
      const oldItem = JSON.parse(item.oldItem);
      item.name = oldItem.name;
      item.duration = oldItem.duration;
      item.beginTime = oldItem.beginTime;
      item.endTime = oldItem.endTime;
      item.time = [oldItem.beginTime, oldItem.endTime];
      item.edit = false;
    },
    onBeforeRemove(array, index) {
      this.dialogShow = true;
      this.dialogData = { array: array, index: index };
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: `是否删除“${array[index].name || ""}”的任务时长？`,
      };
    },
    remove(array, index) {
      array.splice(index, 1);
      const copyObj = JSON.parse(JSON.stringify(this.coachItem));
      copyObj.coachTaskType[this.coachTaskTypeIndex(3)].totalNumberOfTasks =
          this.coachItem.coachTaskType[this.coachTaskTypeIndex(3)].coachTaskDetails.length;
      const details = this.coachItem.coachTaskType[this.coachTaskTypeIndex(3)].coachTaskDetails;
      let total = 0;
      if (Array.isArray(details) && details.length) {
        details.forEach(item => {
          total += Number(item.duration);
        });
      }
      total = total.toString();
      if (total.indexOf(".") !== -1) {
        total = Number(total.substring(0, total.indexOf(".") + 2));
      }
      copyObj.coachTaskType[this.coachTaskTypeIndex(3)].totalTaskDuration = total;
      this.coachItem = Object.assign(this.coachItem, copyObj);
    },
    add(array) {
      const item = {
        beginTime: "",
        duration: "",
        endTime: "",
        time: null,
        orderIndex: 1,
        name: "",
        edit: false,
      };
      if (array.length) {
        const lastItem = array[array.length - 1];
        array.push(
          Object.assign(item, {
            orderIndex: lastItem.orderIndex + 1,
            oldItem: JSON.stringify(item),
          })
        );
      } else {
        item.oldItem = JSON.stringify(item);
        array.push(item);
      }
    },
    itemChange(item) {
      if (item.time) {
        item.beginTime = item.time[0];
        item.endTime = item.time[1];
      } else {
        item.beginTime = "";
        item.endTime = "";
      }
    },
    cancelBtn() {
      this.$router.go(-1);
    },
    commitBtn() {
      const that = this;
      let editStatus = false;
      const params = this.coachItem.coachTaskType.reduce((init, item) => {
        if (item.type === 1 || item.type === 2 || item.type === 3) {
          item.coachTaskDetails.forEach(async it => {
            it.edit && (editStatus = true);
            const preObj = it.revised === undefined ? {
              coachId: that.coachid,
              beginTime: it.beginTime,
              endTime: it.endTime,
              name: it.name,
              type: item.type,
              duration: it.duration,
            }
              : {
                coachId: that.coachid,
                beginTime: it.beginTime,
                endTime: it.endTime,
                name: it.name,
                type: item.type,
                duration: it.duration,
                revised: it.revised,
              };
            await init.push(Object.assign(preObj, it.id ? { id: it.id } : {})
            );
          });
        }
        return init;
      }, []);
      if (editStatus) {
        this.$message.error("请先确认任务信息");
        return false;
      }
      if (params.some(item => item.duration <= 0)) {
        this.$message.error("任务时长不能少于等于0");
        return false;
      }
      if (params.some(item => !item.name || !item.beginTime || !item.endTime)) {
        this.$message.error("请填写完整任务信息");
        return false;
      }
      this.$Api.coach.postTaskSave(params).then(res => {
        this.$message.success("保存成功");
        this.$router.go(-1);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-range-input {
  background-color: transparent;
}
.btns {
  align-items: center;
  justify-content: center;
  margin-top: 16px;
}
.duration-edit {
  .el-row {
    height: 50px;
    margin-bottom: 10px;
    font-size: 14px;
    display: flex;
    align-items: center;

    &:last-child {
      margin-bottom: 0;
    }
    &:first-child {
      margin-top: 10px;
    }
  }
}

.task-detail {
  margin-top: 30px;
  font-size: 14px;

  .task-detail-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 30px;
  }

  .time,
  .duration {
    // width: 100px;
    padding-left: 20px;
  }

  .detail-table {
    margin-top: 30px;

    .detail-table_head {
      background: #494949;
      color: #fff;
      padding: 20px 30px;
    }
    .detail-table_body {
      background: #f7f7f7;
      padding: 0 30px;
      .row {
        flex-direction: row;
        justify-content: space-between;
        padding: 37px 0;
        border-bottom: 1px solid #bbbbbb;
        &:last-child {
          border: none;
        }

        > div {
          display: flex;
          flex-wrap: nowrap;
          justify-content: flex-start;
          align-items: center;
          flex: inherit;
          &:last-child {
            margin-right: 0;
          }
          .label {
            flex-wrap: nowrap;
            white-space: nowrap;
            margin-right: 15px;
            font-weight: 500;
            min-width: 28px;
            &.w56 {
              width: 56px;
            }
          }
          .content {
            width: 40px;
          }
          &.name {
            .content {
              width: 126px;
            }
          }
          &.time-cont {
            .content {
              width: 310px;
            }
          }
          &.duration-time {
            width: 131px;
            text-align: left;
            .edit-duration {
              display: flex;
              align-items: center;
              span:first-of-type{
                font-family: 'Noto Sans SC';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                color: #494949;
                margin-left: 20px;
              }
              span:nth-of-type(2){
                margin: 0 10px;
              }
            }
          }
        }
      }
    }
    .operation {
      width: 121px;
      text-align: left;
    }
  }
}

.add-new-task {
  padding: 30px 0;
  text-align: center;

  .add-button {
    cursor: pointer;
    display: inline-block;
    padding: 10px;
    color: #494949;
    border: 1px dashed #494949;
  }
}
</style>
<style lang="less">
.detail-table {
  .el-input__inner {
    background: transparent;
  }
}
</style>
